export default {"src":"/_next/static/media/destination.36d81e14.svg","height":16,"width":16};